import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
} from "../services/types/ComponentTypes";

export const screen_2226_time_shift_summary: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Time Shifts",
        fabAction: {
            type: "add",
            screenId: "2227",
            // action: "hrm/time_shift_add",
        },
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                childComponents: [
                    {
                        componentType: ComponentType.SUMMARY_LIST,
                        Name: "time_shift_summary",
                        apiname: "time_shift_summary",
                        titleValue: "shift_name",
                        Form: {
                            Name: "time_shift_summary",
                            TableName: "time_shift",
                            Filter: "time_shift.soft_delete=0",
                            Fields: [
                                {
                                    IncludeLabel: true,
                                    Label: "Shift Code",
                                    BindValue: "shift_code",
                                    Json_Attribute: "shift_code",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Shift Name",
                                    BindValue: "shift_name",
                                    Json_Attribute: "shift_name",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Shift Type",
                                    BindValue: "shift_type",
                                    Json_Attribute: "shift_type",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Start Time",
                                    BindValue: "start_time",
                                    Json_Attribute: "start_time",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "End Time",
                                    BindValue: "end_time",
                                    Json_Attribute: "end_time",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Total Duration",
                                    BindValue: "total_work_duration",
                                    Json_Attribute: "total_work_duration",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Status",
                                    BindValue: "status",
                                    Json_Attribute: "status",
                                    componentType: ComponentType.TEXT_FIELD,
                                    showInSummary: true
                                },
                                {
                                    IncludeLabel: true,
                                    Label: "Last Updated",
                                    BindValue: "modified_at",
                                    Json_Attribute: "modified_at",
                                    componentType: ComponentType.DATE_FIELD,
                                    showInSummary: true
                                }
                            ]
                        },
                        SummeryActions: [
                            {
                                Action: {
                                    Action: "Navigate",
                                    Navigate: "hrm/time_shift_add/<id>"
                                },
                                ActionType: "Edit",
                                ScreenId: "2227"
                            },
                            {
                                Action: {
                                    Action: "Delete",
                                    Module: "time_shift_summary"
                                },
                                ActionType: "Delete",
                                confirmTitle: "Delete shift",
                                confirmMessage:
                                    "Are you sure you want to delete this shift? This shift may be currently mapped to user groups. Deleting it will remove the assigned schedule for all associated employees."
                            }
                        ]
                    }
                ]
            }
        ]
    }
];
